import React from "react";
import RevenueEntry from "./RevenueEntry";
import { LOAD_PRES_CLUB_REVENUE_SUCCESS } from "../../redux/actions/ActionTypes";
import DashBoardPanel from "./dashboard/DashboardPanel";
import Loading from "../common/loading/Loading";
import MaskedRevenueEntry from "./MaskedRevenueEntry";

function RevenueLeaders({data, isAdmin}) {

    return (
        <DashBoardPanel title="Rank By Revenue">
            <Loading api={LOAD_PRES_CLUB_REVENUE_SUCCESS} />
            <table className="leaderboard table-hover">
                <thead>
                    <tr>
                        <th className="leader-entry number-data">Rank</th>
                        <th className="leader-entry">Name</th>
                        {isAdmin ? <th className="leader-entry number-data">Revenue</th> : <th></th>}
                    </tr>                            
                </thead>
                <tbody>
                    { data.entries.map(p =>
                        p.isSelf || p.isReport || isAdmin ?
                        (<RevenueEntry rank={p.rank} 
                            name={p.firstName + " " + p.lastName} 
                            value={p.revenue} 
                            isHighlighted={p.isSelf}/>)
                        : (<MaskedRevenueEntry
                            rank={p.rank}
                            value={p.revenue}
                            isHighlighted={p.isSelf} />)) }                      
                </tbody>
            </table>            
        </DashBoardPanel>

    );
}

export default RevenueLeaders;